module.exports = __webpack_public_path__ + "img/david-mixner.jpg?80ec7931c02e378a8fdba0e689cee793";